/***
 *
 *   SIGN IN
 *   Phase 9 — reference signin chrome. Keep magic-link toggle + live APIs.
 *
 **********/

import React, { useContext, useState, useEffect } from 'react';
import {
    Animate,
    ViewContext,
    Button,
    Form,
    Link,
    Message,
    useLocation,
    useNavigate,
} from 'components/lib';
import { AuthPage } from 'components/auth/authPage';
import { AuthContext } from 'app/auth';
import { useTranslate } from 'app/translations';

export function Signin(props) {
    const { _t } = useTranslate();
    const authContext = useContext(AuthContext);
    const viewContext = useContext(ViewContext);
    const location = useLocation();
    const navigate = useNavigate();

    const [useMagic, setUseMagic] = useState(false);
    const [magicLinkSent, setMagicLinkSent] = useState(false);
    const [form, setForm] = useState({
        email: {
            label: _t('email.label'),
            type: 'email',
            required: true,
        },
        password: {
            label: _t('password.label'),
            type: 'password',
            required: true,
        },
        forgotpassword: {
            type: 'link',
            url: '/forgotpassword',
            text: _t('password.forgot.question'),
        },
    });

    useEffect(() => {
        const qs = location.search;
        if (qs.includes('error')) {
            const msg = decodeURIComponent(qs.substring(qs.indexOf('?error=') + 7));
            viewContext.notification.show(msg, 'error');
        }
    }, [location.search, viewContext.notification]);

    function toggleMagicLink(next) {
        const f = { ...form };
        f.password.type = next ? 'hidden' : 'password';
        f.password.required = !next;
        f.forgotpassword.type = next ? 'hidden' : 'link';
        setForm(f);
        setUseMagic(next);
    }

    return (
        <Animate type="pop">
            <AuthPage
                title={_t('signin.to') + ' Valetify'}
                description={_t('signin.description')}
                footer={
                    <>
                        {_t('organization.dont')} <Link url="/signup" text={_t('signup.label')} />
                    </>
                }>
                {magicLinkSent && (
                    <Message
                        title={_t('email.check')}
                        type="success"
                        text={_t('email.linkInfo')}
                    />
                )}

                <div className="mb-2 flex justify-center lg:justify-start">
                    <Button
                        text={useMagic ? _t('password.use') : _t('magic.useInstead')}
                        variant="secondary"
                        size="sm"
                        icon={useMagic ? 'shield' : 'star'}
                        action={() => toggleMagicLink(!useMagic)}
                    />
                </div>

                <Form
                    data={form}
                    method="POST"
                    url={useMagic ? '/api/auth/magic' : '/api/auth'}
                    buttonText={useMagic ? _t('magic.send') : _t('signin.label')}
                    auth={false}
                    callback={(res) => {
                        useMagic
                            ? setMagicLinkSent(true)
                            : res.data['2fa_required']
                              ? navigate(`/signin/otp?token=${res.data.token}`)
                              : navigate(authContext.signin(res));
                    }}
                />
            </AuthPage>
        </Animate>
    );
}
